module.exports = __webpack_public_path__ + "img/attachement-top.23646396.svg";